<template>
  <div>
    <header>
      <!-- NAVBAR -->
      <nav class="indigo">
        <!-- responsive layout -->
        <div class="nav-wrapper" :class="dashboard && !mobile ?  'container' : ''">
          <div class="row">
            <div class="col s12">
              <!-- mobile menu icon -->
              <a
                v-if="home || dashboard && $store.getters.getUser.role === 'admin'"
                href="#"
                data-target="sidenav-1"
                class="left sidenav-trigger hide-on-medium-and-up"
              >
                <i class="material-icons">menu</i>
              </a>

              <!-- logo -->
              <router-link
                :to="{ name: 'home' }"
                tag="a"
                class="brand-logo"
                :class="home || $store.getters.getUser.role === 'student' || $route.name === 'login' || $route.name === 'lesson' ? 'center' : $route.name === 'notFound' && !dashboard ? 'center' : ''"
                :style="!mobile && home ? { 'margin-left': '130px' } : ''"
              >Prep2Go</router-link>

              <!-- menu for admins -->
              <ul
                v-if="dashboard && $store.getters.getUser.role === 'admin'"
                id="nav-mobile"
                class="right hide-on-med-and-down"
              >
                <router-link :to="{ name: 'home' }" tag="li">
                  <a href>Home</a>
                </router-link>

                <router-link :to="{ name: 'users', params: { role: 'students' } }" tag="li">
                  <a href>Users</a>
                </router-link>

                <router-link
                  v-if="$store.getters.getUser.role === 'admin'"
                  @click.native="close"
                  :to="{ name: 'studies' }"
                  tag="li"
                >
                  <a href>Studies</a>
                </router-link>

                <router-link
                  v-if="$store.getters.getUser.role === 'admin'"
                  @click.native="close"
                  :to="{ name: 'lessons' }"
                  tag="li"
                >
                  <a href>Lessons</a>
                </router-link>

                <router-link
                  @click.native="$store.dispatch('logout')"
                  :to="{ name: 'login' }"
                  tag="li"
                >
                  <a href>Logout</a>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <!-- LEFT SIDEBAR	 -->
    <ul id="sidenav-1" class="sidenav" :class="home ? 'sidenav-fixed' : ''">
      <li>
        <a class="subheader">{{ home ? 'Levels' : 'Menu' }}</a>
      </li>

      <li v-if="home">
        <a
          v-for="level in $store.getters.getInfo"
          :key="level.level"
          @click="$store.commit('setLevelLesson', { level: level.level, lesson: '' })"
          :style="$store.getters.getUser.role === 'admin' ? '' : $store.getters.getUser.level >= level.level ? '' : { 'cursor': 'not-allowed' }"
          :class="$store.getters.getUser.role === 'admin' || $store.getters.getUser.level > level.level || $store.getters.getUser.level == level.level ? 'modal-trigger' : ''"
          href="#lessonModal"
        >
          <span
            class="chip"
            :class="$store.getters.getUser.role === 'admin' ? 'green' : $store.getters.getUser.level > level.level ? 'green' : $store.getters.getUser.level == level.level && $store.getters.getInfo[level.level - 1].lessons.length < $store.getters.getUser.lesson ? 'green' : $store.getters.getUser.level == level.level ? 'amber': 'red'"
          ></span>
          Level {{ level.level }}
        </a>
      </li>

      <hr v-if="home" />

      <li v-if="$store.getters.getUser.role === 'admin' && home">
        <a class="subheader">Menu</a>
      </li>

      <router-link v-if="$store.getters.getUser.role === 'admin'" :to="{ name: 'home' }" tag="li">
        <a href>Home</a>
      </router-link>

      <router-link
        v-if="$store.getters.getUser.role === 'admin'"
        @click.native="close"
        :to="{ name: 'users', params: { role: 'students' } }"
        tag="li"
      >
        <a href>Students</a>
      </router-link>

      <router-link
        v-if="$store.getters.getUser.role === 'admin'"
        @click.native="close"
        :to="{ name: 'users', params: { role: 'admins' } }"
        tag="li"
      >
        <a href>Admins</a>
      </router-link>

      <router-link
        v-if="$store.getters.getUser.role === 'admin'"
        @click.native="close"
        :to="{ name: 'studies' }"
        tag="li"
      >
        <a href>Studies</a>
      </router-link>

      <router-link
        v-if="$store.getters.getUser.role === 'admin'"
        @click.native="close"
        :to="{ name: 'lessons' }"
        tag="li"
      >
        <a href>Lessons</a>
      </router-link>

      <router-link @click.native="logout" :to="{ name: 'login' }" tag="li">
        <a href>Logout</a>
      </router-link>
    </ul>
  </div>
</template>


<script>
export default {
  created() {
    $(document).ready(() => $(".sidenav").sidenav());
  },
  methods: {
    close() {
      M.Sidenav.getInstance($(".sidenav")).close();
    },
    logout() {
      this.$store.dispatch("logout");
      this.close();
    }
  },
  computed: {
    mobile() {
      return window.innerWidth < 992 ? true : false;
    },
    dashboard() {
      return this.$route.path.split("/")[1] === "dashboard";
    },
    home() {
      return this.$route.name === "home";
    }
  }
};
</script>


<style scoped>
.chip {
  width: 0px;
  height: 0px;
  padding: 5px;
  margin-bottom: -0.2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue